<template>
    <div>
        <div id="courseModal" class="modal">
            <div class="modal-contents">
                <span class="close" @click="modalClose()">&times;</span>
                <div class="update-course" v-show="addCourse">
                    <div class="modal-heading">
                        <h1 class="main-heading">Add New Course</h1>
                    </div>
<!--                    <ul class="nav nav-tabs nav-padd-20">-->
<!--                        <li class="active"><a data-toggle="tab" href="#email_invite">Single Add</a></li>-->
<!--                        <li><a data-toggle="tab" href="#bulk_invite">Bulk Add</a></li>-->
<!--                    </ul>-->
<!--                    <div class="tab-content">-->
<!--                        <div id="email_invite" class="tab-pane fade in active">-->
                            <div class="update-cour">
                                <div class="row">
                                    <div class="col-md-12">
                                        <form id="add-new-course" @submit.prevent="addNewCourse($event)">
                                            <div class="disTable">
                                                <div class="form-group">
                                                    <label class="ep-input-label">Course Name</label>
                                                    <multiselect
                                                        v-model="value"
                                                        :height="300"
                                                        :options="options"
                                                        :loading="isLoading"
                                                        @search-change="asyncFind"
                                                        :multiple="false"
                                                        :taggable="true"
                                                        :close-on-select="true"
                                                        :clear-on-select="false"
                                                        :preserve-search="true"
                                                        tag-placeholder="Add this as new tag"
                                                        placeholder="Choose or Enter Course Name"
                                                        @tag="addTag"
                                                        label="course_name"
                                                        track-by="course_name"
                                                    >
                                                        <span slot="noOptions">Enter any keyword to search</span>
                                                        <span slot="noResult">No skill found. Enter Another Keyword to search</span>
                                                    </multiselect>
                                                    <!--                                            <input type="text" class="form-control dash-input" id="add_course_name"-->
                                                    <!--                                                   placeholder="Course Name" v-model="cName">-->
                                                    <div v-html="cNameError" class="form-text text-muted"></div>
                                                </div>
                                                <div class="form-group" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                                    <label class="ep-input-label">Course Type</label>
                                                    <ul>
                                                        <li class="service-list">
                                                            <input type="radio" id="cOne" value="Years" v-model="cType" checked>
                                                            <label for="cOne">Yearly</label>
                                                        </li>
                                                        <li class="service-list">
                                                            <input type="radio" id="cTwo" value="Semesters" v-model="cType">
                                                            <label for="cTwo">Semesters</label>
                                                        </li>
                                                    </ul>
                                                    <!--<input type="text" class="form-control dash-input" id="add_course_duration" placeholder="Course Duration" v-model="cDuration">-->
                                                </div>
                                                <div class="form-group" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                                    <label class="ep-input-label" for="add_course_duration">Course Duration</label>
                                                    <input type="number" class="form-control dash-input" id="add_course_duration"
                                                           placeholder="Course Duration" v-model="cDuration" min="1" max="10">
                                                    <div v-html="cDurationError" class="form-text text-muted"></div>
                                                </div>
                                                <div class="form-group">
                                                    <label class="ep-input-label">Enter Sections</label>
                                                    <tags-input element-id="sections_tags"
                                                                v-model="sections_tags"
                                                                :typeahead="false"
                                                                :onlyExistingTags="false"
                                                                :deleteOnBackspace="true"
                                                                :allowDuplicates="false"></tags-input>
                                                </div>
                                                <div class="align-center">
                                                    <div class="form-group">
                                                        <button type="submit" class="add-course">Add Course</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
<!--                        </div>-->
<!--                        <div id="bulk_invite" class="tab-pane fade">-->
<!--                            <div class="update-cour invite-main">-->
<!--                                <div class="row">-->
<!--                                    <div class="col-md-6 col-md-offset-3">-->
<!--                                        <form id="invite-via-file" @submit.prevent="inviteFile($event)">-->
<!--                                            <div class="form-group">-->
<!--                                                <label class="ep-input-label float-left">Upload CSV File Here</label>-->
<!--                                                <input type="file" class="file-input" id="uploadFile" ref="file"-->
<!--                                                       v-on:change="handleFileUpload()" accept=".csv"/>-->
<!--                                                <label class="file-dropable" for="uploadFile">-->
<!--                                                    <i id="uploadIcon" class="fas fa-cloud-upload-alt"></i>-->
<!--                                                    <h4 v-html="file_name"></h4>-->
<!--                                                </label>-->
<!--                                            </div>-->
<!--                                            <div v-html="iFileEmailsError" class="form-text text-muted"></div>-->
<!--                                            <div class="col-md-12 text-center">-->
<!--                                                <div class="form-group">-->
<!--                                                    <button type="submit" class="ss-button margin-top-0">Add</button>-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </form>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                </div>
                <div class="update-course" v-show="!addCourse">
                    <div class="modal-heading">
                        <h1 class="main-heading">Update Course</h1>
                    </div>
                    <div class="update-cour">

                        <div class="row">
                            <div class="col-md-12">
                                <form id="update-course" @submit.prevent="updateCourse($event)">
                                    <div class="disTable">
                                        <div class="form-group">
                                            <label class="ep-input-label" for="course_name">Course Name</label>
                                            <input type="text" class="form-control dash-input" id="course_name"
                                                   placeholder="Course Name" v-model="eName">
                                            <div v-html="eNameError" class="form-text text-muted"></div>
                                        </div>
                                        <div class="form-group" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                            <label class="ep-input-label">Course Type</label>
                                            <ul>
                                                <li class="service-list">
                                                    <input type="radio" id="eOne" value="Years" v-model="eType">
                                                    <label for="eOne">Years</label>
                                                </li>
                                                <li class="service-list">
                                                    <input type="radio" id="eTwo" value="Semesters" v-model="eType">
                                                    <label for="eTwo">Semester</label>
                                                </li>
                                            </ul>
                                            <!--<input type="text" class="form-control dash-input" id="course_duration" placeholder="Course Duration" v-model="eDuration">-->
                                        </div>
                                        <div class="form-group" v-if="this.$store.getters.getUser['business_activity'] != 'School'">
                                            <label class="ep-input-label" for="course_duration">Course Duration</label>
                                            <input type="number" class="form-control dash-input" id="course_duration"
                                                   placeholder="Course Duration" v-model="eDuration">
                                            <div v-html="eDurationError" class="form-text text-muted"></div>
                                        </div>
                                        <div class="form-group">
                                            <label class="ep-input-label">Enter Sections</label>
                                            <tags-input element-id="eSectionsTags"
                                                        v-model="eSectionsTags"
                                                        :typeahead="false"
                                                        :onlyExistingTags="false"
                                                        :deleteOnBackspace="true"
                                                        :allowDuplicates="false"></tags-input>
                                        </div>
                                        <div class="align-center">
                                            <div class="form-group">
                                                <button type="submit" class="add-course">Update Course</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios';
    import toastr from  '../../public/js/toastr.js';
    import VoerroTagsInput from '@voerro/vue-tagsinput';
    import Multiselect from "vue-multiselect";
    import {hideLoader, requestHeaders, showLoader} from "../_helpers/apiHelper";
    Vue.component('tags-input', VoerroTagsInput);
    Vue.component('multiselect', Multiselect)

    export default {
        components: {
            Multiselect,
            VoerroTagsInput
        },
        data() {
            return {
                value: [],
                options: [],
                addCourse: true,
                cName: '',
                cDuration: '',
                cType: 'Years',
                eName: '',
                eType: '',
                eDuration: '',
                cNameError: '',
                cDurationError: '',
                eNameError: '',
                eDurationError: '',
                eNameAlready: '',
                eTypeAlready: '',
                eDurationAlready: '',
                sections_tags: [],
                eSectionsTags: [],
                clId: '',
                isLoading: false,
                file: '',
                file_name: 'Upload File Here',
                fileinput: '',
                iFileEmailsError: '',
                iData: '',
            }
        },
        mounted() {
            this.asyncFind("");
        },
        methods: {
            modalClose() {
                $('#courseModal').css({"display": "none"});
            },
            addTag(newTag) {
                console.log(this.value);
                console.log(newTag);
                this.value = {course_name:newTag};
            },
            handleFileUpload() {
                var t = this;
                t.file_name = '';
                t.iFileEmailsError = '';
                t.file = this.$refs.file.files[0];
                t.file_name = t.file['name'];
                var icon_elem = document.getElementById('uploadIcon');
                if (t.file_name != "") {
                    icon_elem.className = 'fas fa-file-alt';
                } else {
                    icon_elem.className = 'fas fa-cloud-upload-alt';
                }

                const reader = new FileReader();
                reader.readAsText(t.file);
                reader.onload = e => fileMain(e.target.result);

                function fileMain(e) {
                    t.iData = e;
                }
            },
            inviteFile() {
                var t = this;
                var result = [];
                var iCourses = {};
                t.iFileEmailsError = '';


                if (t.iData.length == '') {
                    t.iFileEmailsError = 'Please upload file';
                    return false;
                }

                var data = t.iData.split(/\r\n|\n/);

                var first_row = data[0].trim().split(',');
                for (var i = 1; i < data.length; i++) {
                    var d = data[i].split(',');
                    if (d.length && d.toString() != '') {
                        iCourses = {};
                        for (var j = 0; j < first_row.length; j++) {
                            if (first_row[j].toLowerCase() == 'name') {
                                iCourses['course_name'] = d[j]
                            } else if (first_row[j].toLowerCase() == 'years') {
                                iCourses['years'] = d[j]
                            } else if (first_row[j].toLowerCase() == 'semesters') {
                                iCourses['semesters'] = d[j]
                            }
                        }
                        if(iCourses.course_name){
                            result.push(iCourses);
                        }
                    }
                }
                if(!result.length){
                    alert('Please Enter Correct Format of File');
                    return false;
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-profile/save-course`, {
                    courses: result,
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            var course = res['data']['response']['courses'];
                            t.$store.dispatch("setCourses", course);
                            $('#courseModal').css({"display": "none"});
                            toastr.success('Courses Successfully Added', 'Success');
                            // t.iEmails = '';
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            anotherModal(id) {
                if (id) {
                    var t = this;
                    t.clId = id;
                    var data = t.$store.getters.getCourseById(id);
                    t.eName = t.eNameAlready = data[0]['course_name'];
                    t.eType = t.eTypeAlready = data[0]['type'];
                    t.eDuration = t.eDurationAlready = data[0]['course_duration'];
                    t.eSectionsTags = [];
                    if(data[0]['collegeSections'].length) {
                        for(var i=0 ; i<data[0]['collegeSections'].length ; i++){
                            var demo = {};
                            demo['key'] = data[0]['collegeSections'][i]['section_enc_id'];
                            demo['value'] = data[0]['collegeSections'][i]['section_name'];
                            t.eSectionsTags.push(demo);
                        }
                    }
                    t.addCourse = false;
                    $('#courseModal').css({"display": "block"});
                } else {
                    this.addCourse = true;
                    $('#courseModal').css({"display": "block"});
                }
            },
            asyncFind(query) {
                this.isLoading = true
                var t = this;
                var url = this.$store.getters.getDomain;
                axios.get(`${url}api/v2/utilities/pool-courses?keyword=${query}`).then(function (response) {
                    t.options = response['data'];
                    t.isLoading = false;
                });
            },
            addNewCourse() {
                var t = this;
                t.cNameError = "";
                t.cDurationError = "";
                if (!t.value && t.cDuration == "" && t.$store.getters.getUser['business_activity'] != 'School') {
                    t.cNameError = "Course name cannot be blank.";
                    t.cDurationError = "Course duration cannot be blank.";
                    return false;
                }
                if (!t.value.course_name) {
                    t.cNameError = "Course name cannot be blank.";
                    return false;
                }
                if (t.cDuration == "" && t.$store.getters.getUser['business_activity'] != 'School') {
                    t.cDurationError = "Course duration cannot be blank.";
                    return false;
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-profile/save-course`, {
                    course_name: t.value.course_name,
                    type: t.cType,
                    course_duration: t.cDuration,
                    sections: t.sections_tags
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            var course = res['data']['response']['courses'];
                            t.$store.dispatch("setCourses", course);
                            toastr.success('Course Successfully Added', 'Success');
                            $('#courseModal').css({"display": "none"});
                            t.cName = "";
                            t.cDuration = "";
                            t.sections_tags = [];
                        } else if (res['data']['response']['status'] == 409) {
                            toastr.error(res['data']['response']['message'], 'Oops!!');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
            updateCourse() {
                var t = this;
                t.eNameError = "";
                t.eDurationError = "";
                if (t.eName == "" && t.eDuration == "") {
                    t.eNameError = "Course name cannot be blank.";
                    t.eDurationError = "Course duration cannot be blank.";
                    return false;
                }
                if (t.eName == "") {
                    t.eNameError = "Course name cannot be blank.";
                    return false;
                }
                if (t.eDuration == "") {
                    t.eDurationError = "Course duration cannot be blank.";
                    return false;
                }
                showLoader();
                var url = t.$store.getters.getDomain;

                axios.post(`${url}api/v2/college-profile/update-course`, {
                    course_id: t.clId,
                    course_name: t.eName,
                    course_duration: t.eDuration,
                    type: t.eType,
                    sections: t.eSectionsTags
                }, {headers: requestHeaders()})
                    .then(res => {
                        hideLoader();
                        if (res['data']['response']['status'] == 200) {
                            var course = res['data']['response']['courses'];
                            t.$store.dispatch("setCourses", course);
                            toastr.success('Course Successfully Updated', 'Success');
                            $('#courseModal').css({"display": "none"});
                            t.eName = '';
                            t.eDuration = '';
                        } else if (res['data']['response']['status'] == 409) {
                            toastr.error(res['data']['response']['message'], 'Oops!!');
                        } else {
                            toastr.error('Some error occurred. Try again later', 'Oops!!');
                        }
                    })
            },
        }
    }
</script>

<style scoped>
    .modal-contents {
        overflow-y: scroll !important;
        position: relative;
        background-color: #fff;
    }

    .modal-heading {
        text-align: center;
        padding: 10px;
    }

    .update-cour {
        width: 100%;
    }

    form {
        max-width: 550px;
        margin: 0 auto;
        padding: 0px 15px;
    }

    .add-course {
        background: #00a0e3;
        padding: 10px 15px;
        color: #fff;
        border-radius: 10px 0px 10px 0;
        font-size: 13px;
        border: none;
        margin-top: 15px;
    }

    .add-course:hover {
        text-decoration: none;
        border-radius: 0px;
        transition: .5s all;
    }

    .align-center {
        text-align: center;
    }

    /*----tabs----*/
    .nav-tabs > li {
        text-align: center;
        margin-bottom: -1px;
        float: none;
        display: inline-block;
    }

    .nav-tabs li.active a {
        border: 0px !important;
    }

    .nav-tabs > li > a {
        border-radius: 0;
        font-family: 'Open Sans', sans-serif;
        font-size: 12px;
        padding: 12px 20px;
        margin-right: 0;
        background-color: #fff;
        color: #222;
    }

    .nav-tabs > li.active a, .nav-tabs > li.active a:hover, .nav-tabs > li.active a:focus {
        color: #fff;
        background-color: #00a0e3;
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        transition: .2s all;
    }

    .nav-tabs > li > a:hover {
        box-shadow: 2px 4px 17px rgba(221, 216, 216, 0.8);
        color: #00a0e3;
    }

    .nav-tabs, .nav-tabs > li > a, .nav-tabs > li > a:hover {
        border: none;
    }

    ul.nav.nav-tabs.nav-padd-20 {
        text-align: center;
        margin-bottom: 20px;
    }
    .file-input {
        height: 0px;
        visibility: hidden;
    }

    .file-dropable {
        width: 100%;
        height: 150px;
        border: 1px dashed #eee;
        cursor: pointer;
        padding: 40px;
        text-align: center;
    }

    .file-dropable i {
        font-size: 34px;
    }

    /*----tabs end----*/
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>